import { type Project } from '../models';
import RecordFilter from './RecordFilter';

class ProjectFilter extends RecordFilter {
  matches(record: { project: Project }) {
    return super.matches(record.project);
  }
}

export default ProjectFilter;
